import type { Letter } from '@/lib/api';
import { LetterCard } from './letter-card';

interface LetterListProps {
  letters: Letter[];
  emptyIcon?: React.ReactNode;
  emptyTitle: string;
  emptyDescription: string;
  showSender?: boolean;
  showRecipient?: boolean;
}

export function LetterList({
  letters,
  emptyIcon,
  emptyTitle,
  emptyDescription,
  showSender,
  showRecipient
}: LetterListProps) {
  const safeLetters = Array.isArray(letters) ? letters : [];

  if (safeLetters.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-warm/30 mb-4">
          {emptyIcon}
        </div>
        <h3 className="text-lg font-medium text-ink mb-2">{emptyTitle}</h3>
        <p className="text-sepia/70">{emptyDescription}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {safeLetters.map((letter, index) => (
        <LetterCard
          key={letter.id}
          letter={letter}
          index={index}
          showSender={showSender}
          showRecipient={showRecipient}
        />
      ))}
    </div>
  );
}
